import { common } from '../../main/common-sidecar'
import type { IVoyageCameraStarmap } from './voyageCameraStarmap'
import { voyageCameraStarmap } from './voyageCameraStarmap-sidecar'
import { voyageKeyboard } from './voyageKeyboard-sidecar'
import { voyageMenuMain } from './voyageMenuMain-sidecar'

let _isMiddleMouseDown = false
let _mx = 0
let _my = 0
let _sx = 0
let _sy = 0

export function update(obj: IVoyageCameraStarmap) {
  if (voyageMenuMain.get().isOpen) {
    return
  }

  let ap = common.getPhaserScene().game.input.activePointer
  if (ap.middleButtonDown()) {
    if (!_isMiddleMouseDown) {
      _isMiddleMouseDown = true
      _mx = ap.x
      _my = ap.y
      _sx = obj.cameraX
      _sy = obj.cameraY
    }
    voyageCameraStarmap.setCameraXY(_sx + -(ap.x - _mx), _sy + -(ap.y - _my))
  } else {
    _isMiddleMouseDown = false

    let dt = common.getUpdateDelta()
    let speed = 1000
    let dirX = 0
    let dirY = 0

    let keys = voyageKeyboard.getKeys()

    if (keys.cameraLeft) {
      dirX -= speed
    }
    if (keys.cameraRight) {
      dirX += speed
    }
    if (keys.cameraUp) {
      dirY -= speed
    }
    if (keys.cameraDown) {
      dirY += speed
    }

    voyageCameraStarmap.setCameraXY(
      obj.cameraX + dirX * dt,
      obj.cameraY + dirY * dt,
    )
  }
}
